import {
	CHECK_CLIENT_COMPANY_NAME,
	CHECK_USERNAME,
	RegisterAction,
} from 'store/types/register';

export interface RegisterStore {
	isUsernameExists: boolean;
	isCompanyNameExists: boolean;
}

const initialState: RegisterStore = {
	isUsernameExists: false,
	isCompanyNameExists: false,
};

export const registerReducer = (
	state = initialState,
	action: RegisterAction,
): RegisterStore => {
	switch (action.type) {
		case CHECK_CLIENT_COMPANY_NAME: {
			return {
				...state,
				isCompanyNameExists: action.payload,
			};
		}
		case CHECK_USERNAME: {
			return {
				...state,
				isUsernameExists: action.payload,
			};
		}

		default: {
			return {
				...state,
			};
		}
	}
};
